const password = password => {
    const rule = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/);

    return rule.test(password) ? null : 'Must contain 8 or more characters & contain Upper Case, Lower Case, Number';
};

export default password;
